import { useEffect, useState } from 'react'

interface Viewport {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  viewportWidth: number
  viewportHeight: number
}

export const useViewport = (): Viewport => {
  const [viewport, setViewport] = useState<Viewport>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    viewportWidth: 0,
    viewportHeight: 0,
  })

  useEffect(() => {
    // Check if window is defined (i.e., we're in a browser environment)
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setViewport({
          isMobile: window.innerWidth < 420,
          isTablet: window.innerWidth >= 420 && window.innerWidth < 768,
          isDesktop: window.innerWidth >= 768,
          viewportWidth: window.innerWidth,
          viewportHeight: window.innerHeight,
        })
      }

      handleResize()

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return viewport
}
